import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Form,
  FormFeedback,
  Input,
  Button,
  Label,
} from "reactstrap";

//import images
import logoLight from "../../../src/assets/images/logo-light.png";
import loginPic from "../../assets/qrcode/qrLogin.jpg";

//formik
import { useFormik } from "formik";
import * as Yup from "yup";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import AuthenticationsServices from "../../Services/AuthenticationService/AuthenticationsServices";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { validationSchema } from "../../QRCodeAdminPage/Update Profile/Component/ValidationSchema";

const BasicSignUp = () => {
  document.title = "Basic SignUp | Velzon - React Admin & Dashboard Template";

  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const navigate = useNavigate(); // Use useNavigate for navigation
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      confirmPassword: "",
      username: "",
      // firstName: "",
      // lastName: "",
      // email: "",
      // address: "",
      // phoneNo: "",
      name: "",
      tagLine: "",
      address1: "",
      address2: "",
      // tel: "",
      contactNo: "",
      website: "",
      // adminEmail: "",
      orgEmail: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      console.log("Form values before API call:", values);
      const payload = {
        password: values.password,
        confirmPassword: values.confirmPassword,
        username: values.username,
        // firstName: values.firstName,
        // lastName: values.lastName,
        // email: values.email,
        // address: values.address,
        // phoneNo: values.phoneNo,
        organizationDto: {
          name: values.name,
          tagLine: values.tagLine,
          address1: values.address1,
          address2: values.address2,
          // tel: values.tel,
          contactNo: values.contactNo,
          email: values.orgEmail, // Assuming this is the same as the user's email
          website: values.website,
          // adminEmail: values.adminEmail,
        },
      };

      try {
        const response = await AuthenticationsServices.Register(payload);
        console.log("API Response:", response);
        if (response) {
          formik.resetForm();
          toast.success("Verification code is sent successfully!");
          navigate("/validate-otp", { state: { email: values.orgEmail } });
        }
      } catch (error) {
        console.error("Error during registration:", error);
        toast.error("An error occurred. Please try again later.");
      }
    },
  });
  const texts = [
    "Order ready-to-use stickers right away!",
    "Build a digital menu accessible by a QR code easy and fast.",
    "Eliminate the need for physical menus, reducing printing costs.",
  ];

  const [currentText, setCurrentText] = useState(texts[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prev) => {
        const currentIndex = texts.indexOf(prev);
        const nextIndex = (currentIndex + 1) % texts.length;
        return texts[nextIndex];
      });
    }, 5000);

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row className="g-0 justify-content-center align-items-stretch">
              <Col
                md={6}
                lg={6}
                xl={6}
                sm={12}
                xs={12}
                className="position-relative"
              >
                <img
                  src={loginPic}
                  alt="Login Illustration"
                  className="img-fluid w-100 h-100 object-fit-cover"
                />
                <div className="position-absolute bottom-0 start-0 w-100 h-100 d-flex flex-column justify-content-end text-white text-center p-3">
                  <p className="mb-2 fs-3 fw-bold">{currentText}</p>
                </div>
              </Col>
              <Col md={6} lg={6} xl={6} sm={12} xs={12}>
                <Card className="h-100 border-0 rounded-0">
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      formik.handleSubmit();
                      return false;
                    }}
                  >
                    <CardBody className="p-4">
                      <div className="text-start ">
                        <h5 className="text-primary">Welcome Back!</h5>
                        <p className="text-muted">
                          Sign up to create an account.
                        </p>
                      </div>
                      {/* <Col md={10} lg={12} className="mb-2"> */}
                      <Col md={12} className="mb-1">
                        <Label>
                          Organization Name<sup className="text-danger">*</sup>
                        </Label>
                        <div>
                          <Input
                            name="name"
                            className="form-control"
                            placeholder="Enter Organization Name"
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.name || ""}
                            invalid={
                              !!(formik.touched.name && formik.errors.name)
                            }
                          />
                          {formik.touched.name && formik.errors.name && (
                            <FormFeedback type="invalid">
                              {formik.errors.name}
                            </FormFeedback>
                          )}
                        </div>
                      </Col>
                      <Row>
                        <Col md={6} xs={12} className="mb-1">
                          <Label>
                            Address<sup className="text-danger">*</sup>
                          </Label>
                          <Input
                            name="address1"
                            className="form-control"
                            placeholder="Enter Address"
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.address1 || ""}
                            invalid={
                              !!(
                                formik.touched.address1 &&
                                formik.errors.address1
                              )
                            }
                          />
                          {formik.touched.address1 &&
                            formik.errors.address1 && (
                              <FormFeedback type="invalid">
                                {formik.errors.address1}
                              </FormFeedback>
                            )}
                        </Col>
                        <Col md={6} xs={12} className="mb-1">
                          <Label>
                            Contact Number<sup className="text-danger">*</sup>
                          </Label>
                          <Input
                            name="contactNo"
                            className="form-control"
                            placeholder="Enter Contact Number"
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.contactNo || ""}
                            invalid={
                              !!(
                                formik.touched.contactNo &&
                                formik.errors.contactNo
                              )
                            }
                          />
                          {formik.touched.contactNo &&
                            formik.errors.contactNo && (
                              <FormFeedback type="invalid">
                                {formik.errors.contactNo}
                              </FormFeedback>
                            )}
                        </Col>
                      </Row>
                      <Col className="mb-1">
                        <Label>
                          Organization Email<sup className="text-danger">*</sup>
                        </Label>
                        <div>
                          <Input
                            name="orgEmail"
                            className="form-control"
                            placeholder="Enter Organization Email"
                            type="email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.orgEmail || ""}
                            invalid={
                              !!(
                                formik.touched.orgEmail &&
                                formik.errors.orgEmail
                              )
                            }
                          />
                          {formik.touched.orgEmail &&
                            formik.errors.orgEmail && (
                              <FormFeedback type="invalid">
                                {formik.errors.orgEmail}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col className="mb-1">
                        <Label>
                          Username<sup className="text-danger">*</sup>
                        </Label>
                        <div>
                          <Input
                            name="username"
                            className="form-control"
                            placeholder="Enter Username"
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.username || ""}
                            invalid={
                              !!(
                                formik.touched.username &&
                                formik.errors.username
                              )
                            }
                          />
                          {formik.touched.username &&
                            formik.errors.username && (
                              <FormFeedback type="invalid">
                                {formik.errors.username}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col md={12} className="mb-1">
                        <Label>Website</Label>
                        <div>
                          <Input
                            name="website"
                            className="form-control"
                            placeholder="Enter Website"
                            type="text"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.website || ""}
                            invalid={
                              !!(
                                formik.touched.website && formik.errors.website
                              )
                            }
                          />
                          {formik.touched.website && formik.errors.website && (
                            <FormFeedback type="invalid">
                              {formik.errors.website}
                            </FormFeedback>
                          )}
                        </div>
                      </Col>
                      <Col md={12} className="mb-1">
                        <Label>Tagline</Label>
                        <Input
                          name="tagLine"
                          className="form-control"
                          placeholder="Enter Tagline"
                          type="textarea"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.tagLine || ""}
                          invalid={
                            !!(formik.touched.tagLine && formik.errors.tagLine)
                          }
                        />
                        {formik.touched.tagLine && formik.errors.tagLine && (
                          <FormFeedback type="invalid">
                            {formik.errors.tagLine}
                          </FormFeedback>
                        )}
                      </Col>
                      <Row>
                        <Col md={6} xs={6} className="mb-1">
                          <Label>
                            Password<sup className="text-danger">*</sup>
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                          <Input
                            name="password"
                            className="form-control"
                            placeholder="Enter Password"
                            type={passwordShow ? "text" : "password"}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.password || ""}
                            invalid={
                              !!(
                                formik.touched.password &&
                                formik.errors.password
                              )
                            }
                          />
                          {formik.touched.password &&
                            formik.errors.password && (
                              <FormFeedback type="invalid">
                                {formik.errors.password}
                              </FormFeedback>
                            )}
                          <button
                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={() => setPasswordShow(!passwordShow)}
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                          </div>
                        </Col>
                        <Col md={6} xs={6} className="mb-1">
                          <Label>
                            Confirm Password<sup className="text-danger">*</sup>
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="confirmPassword"
                              className="form-control"
                              placeholder="Confirm Password"
                              type={confirmPasswordShow ? "text" : "password"}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.confirmPassword || ""}
                              invalid={
                                !!(
                                  formik.touched.confirmPassword &&
                                  formik.errors.confirmPassword
                                )
                              }
                            />
                            {formik.touched.confirmPassword &&
                              formik.errors.confirmPassword && (
                                <FormFeedback type="invalid">
                                  {formik.errors.confirmPassword}
                                </FormFeedback>
                              )}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                              onClick={() =>
                                setConfirmPasswordShow(
                                  !confirmPasswordShow
                                )
                              }
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <div className="mt-3">
                        <Button color="primary" type="submit" className="w-100">
                          Sign Up
                        </Button>
                      </div>

                      {/* Link to Login Page */}
                      <div className="mt-3 text-center">
                        <p className="mb-0">
                          Already have an account?{" "}
                          <Link to="/login" className="text-primary">
                            Log In
                          </Link>
                        </p>
                      </div>
                      {/* </Col> */}
                    </CardBody>
                  </Form>
                </Card>
              </Col>
            </Row>
            {/* <Row className="justify-content-center">
              <Col md={10} lg={10}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Create New Account</h5>
                    </div>
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          formik.handleSubmit();
                          return false;
                        }}
                        className="needs-formik"
                        action="#"
                      >
                        <div>
                          <Row>
                          
                            <Col lg={6} md={6} xs={12} className="mb-3">
                              <Row>
                                <Col md={12} className="mb-3">
                                  <Label>Organization Name</Label>
                                  <div>
                                    <Input
                                      name="name"
                                      className="form-control"
                                      placeholder="Enter Organization Name"
                                      type="text"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.name || ""}
                                      invalid={
                                        !!(
                                          formik.touched.name &&
                                          formik.errors.name
                                        )
                                      }
                                    />
                                    {formik.touched.name &&
                                      formik.errors.name && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.name}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>

                                <Col md={12} className="mb-3">
                                  <Label for="floatingInput">
                                    Address Line 1
                                  </Label>
                                  <div>
                                    <Input
                                      name="address1"
                                      className="form-control"
                                      placeholder="Enter Address Line 1"
                                      type="text"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.address1 || ""}
                                      invalid={
                                        !!(
                                          formik.touched.address1 &&
                                          formik.errors.address1
                                        )
                                      }
                                    />
                                    {formik.touched.address1 &&
                                      formik.errors.address1 && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.address1}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>

                             
                                <Col md={12} className="mb-3">
                                  <Label>Address Line 2</Label>
                                  <div>
                                    <Input
                                      name="address2"
                                      className="form-control"
                                      placeholder="Enter Address Line 2"
                                      type="text"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.address2 || ""}
                                      invalid={
                                        !!(
                                          formik.touched.address2 &&
                                          formik.errors.address2
                                        )
                                      }
                                    />
                                    {formik.touched.address2 &&
                                      formik.errors.address2 && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.address2}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>

                                <Col md={6} xs={12} className="mb-3">
                                  <Label>Telephone Number</Label>
                                  <div>
                                    <Input
                                      name="tel"
                                      className="form-control"
                                      placeholder="Enter Tel Phone Number"
                                      type="text"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.tel || ""}
                                      invalid={
                                        !!(
                                          formik.touched.tel &&
                                          formik.errors.tel
                                        )
                                      }
                                    />
                                    {formik.touched.tel &&
                                      formik.errors.tel && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.tel}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                                <Col md={6} xs={12} className="mb-3">
                                  <Label>Contact Number</Label>
                                  <div>
                                    <Input
                                      name="contactNo"
                                      className="form-control"
                                      placeholder="Enter Contact Number"
                                      type="text"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.contactNo || ""}
                                      invalid={
                                        !!(
                                          formik.touched.contactNo &&
                                          formik.errors.contactNo
                                        )
                                      }
                                    />
                                    {formik.touched.contactNo &&
                                      formik.errors.contactNo && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.contactNo}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                                <Col className="mb-3">
                                  <Label>Organization Email</Label>
                                  <div>
                                    <Input
                                      name="orgEmail"
                                      className="form-control"
                                      placeholder="Enter Organization Email"
                                      type="email"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.orgEmail || ""}
                                      invalid={
                                        !!(
                                          formik.touched.orgEmail &&
                                          formik.errors.orgEmail
                                        )
                                      }
                                    />
                                    {formik.touched.orgEmail &&
                                      formik.errors.orgEmail && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.orgEmail}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                                <Col md={12} className="mb-3">
                                  <Label>Website</Label>
                                  <div>
                                    <Input
                                      name="website"
                                      className="form-control"
                                      placeholder="Enter Website"
                                      type="text"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.website || ""}
                                      invalid={
                                        !!(
                                          formik.touched.website &&
                                          formik.errors.website
                                        )
                                      }
                                    />
                                    {formik.touched.website &&
                                      formik.errors.website && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.website}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                                <Col md={12} className="mb-3">
                                  <Label>Tagline</Label>
                                  <div>
                                    <Input
                                      name="tagLine"
                                      className="form-control"
                                      placeholder="Enter Tagline"
                                      type="textarea"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.tagLine || ""}
                                      invalid={
                                        !!(
                                          formik.touched.tagLine &&
                                          formik.errors.tagLine
                                        )
                                      }
                                    />
                                    {formik.touched.tagLine &&
                                      formik.errors.tagLine && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.tagLine}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            
                            <Col lg={6} md={6} xs={12} className="mb-3">
                              <Col className="mb-3">
                                <Label for="floatingInput">Username</Label>
                                <div>
                                  <Input
                                    name="username"
                                    className="form-control"
                                    placeholder="Enter Username"
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.username || ""}
                                    invalid={
                                      !!(
                                        formik.touched.username &&
                                        formik.errors.username
                                      )
                                    }
                                  />
                                  {formik.touched.username &&
                                    formik.errors.username && (
                                      <FormFeedback type="invalid">
                                        {formik.errors.username}
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                              <Row>
                                <Col lg={6} md={6} xs={12} className="mb-3">
                                  <Label>First Name</Label>
                                  <div>
                                    <Input
                                      name="firstName"
                                      className="form-control"
                                      placeholder="Enter First Name"
                                      type="text"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.firstName || ""}
                                      invalid={
                                        !!(
                                          formik.touched.firstName &&
                                          formik.errors.firstName
                                        )
                                      }
                                    />
                                    {formik.touched.firstName &&
                                      formik.errors.firstName && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.firstName}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                                <Col lg={6} md={6} xs={12} className="mb-3">
                                  <Label>Last Name</Label>
                                  <div>
                                    <Input
                                      name="lastName"
                                      className="form-control"
                                      placeholder="Enter Last Name"
                                      type="text"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.lastName || ""}
                                      invalid={
                                        !!(
                                          formik.touched.lastName &&
                                          formik.errors.lastName
                                        )
                                      }
                                    />
                                    {formik.touched.lastName &&
                                      formik.errors.lastName && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.lastName}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                              </Row>
                              <Col className="mb-3">
                                <Label>Email</Label>
                                <div>
                                  <Input
                                    name="email"
                                    className="form-control"
                                    placeholder="Enter Email"
                                    type="email"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.email || ""}
                                    invalid={
                                      !!(
                                        formik.touched.email &&
                                        formik.errors.email
                                      )
                                    }
                                  />
                                  {formik.touched.email &&
                                    formik.errors.email && (
                                      <FormFeedback type="invalid">
                                        {formik.errors.email}
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                           
                              <Col className="mb-3">
                                <Label>Address</Label>
                                <div>
                                  <Input
                                    name="address"
                                    className="form-control"
                                    placeholder="Enter Address"
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.address || ""}
                                    invalid={
                                      !!(
                                        formik.touched.address &&
                                        formik.errors.address
                                      )
                                    }
                                  />
                                  {formik.touched.address &&
                                    formik.errors.address && (
                                      <FormFeedback type="invalid">
                                        {formik.errors.address}
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                              <Col className="mb-3">
                                <Label>Phone Number</Label>
                                <div>
                                  <Input
                                    name="phoneNo"
                                    className="form-control"
                                    placeholder="Enter Phone Number"
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.phoneNo || ""}
                                    invalid={
                                      !!(
                                        formik.touched.phoneNo &&
                                        formik.errors.phoneNo
                                      )
                                    }
                                  />
                                  {formik.touched.phoneNo &&
                                    formik.errors.phoneNo && (
                                      <FormFeedback type="invalid">
                                        {formik.errors.phoneNo}
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                              <Row>
                                <Col  md={12} xs={12} className="mb-3">
                                  <Label>Password</Label>
                                  <div>
                                    <Input
                                      name="password"
                                      className="form-control"
                                      placeholder="Enter Password"
                                      type="password"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.password || ""}
                                      invalid={
                                        !!(
                                          formik.touched.password &&
                                          formik.errors.password
                                        )
                                      }
                                    />
                                    {formik.touched.password &&
                                      formik.errors.password && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.password}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                               
                                <Col  md={12} xs={12} className="mb-3">
                                  <Label>Confirm Password</Label>
                                  <div>
                                    <Input
                                      name="confirmPassword"
                                      className="form-control"
                                      placeholder="Confirm Password"
                                      type="password"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.confirmPassword || ""
                                      }
                                      invalid={
                                        !!(
                                          formik.touched.confirmPassword &&
                                          formik.errors.confirmPassword
                                        )
                                      }
                                    />
                                    {formik.touched.confirmPassword &&
                                      formik.errors.confirmPassword && (
                                        <FormFeedback type="invalid">
                                          {formik.errors.confirmPassword}
                                        </FormFeedback>
                                      )}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>

                    
                        <div className="mt-4">
                          <Button
                            color="primary"
                            type="submit"
                            className="w-100"
                          >
                            Sign Up
                          </Button>
                        </div>

                        <div className="mt-3 text-center">
                          <p className="mb-0">
                            Already have an account?{" "}
                            <Link to="/login" className="text-primary">
                              Log In
                            </Link>
                          </p>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row> */}
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default BasicSignUp;
